<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Reporte de contratos
    transition(
      name='fade',
      tag="div",
      v-if="mostrarModalEliminar"
      )
      confirmar-accion-overlay(
        @close="closeModalEliminar"
        @do="eliminar"
        ref="confirmarEliminar"
      )
        span(slot="title") ¿Desea eliminar el contrato?
        span(slot="primaryAction")
          span(v-if="isProcessing") Eliminando...
          span(v-else) Eliminar
        strong Este proceso no se puede deshacer
    transition(
      name='fade',
      tag="div",
      v-if="mostrarModalNotificar"
      )
      confirmar-accion-overlay(
        @close="closeModalNotificar"
        @do="notificar"
        ref="confirmarNotificar"
      )
        span(slot="title") ¿Desea notificar a todos los empleados que no hayan firmado?
        span(slot="primaryAction")
          span(v-if="isProcessing") Notificando...
          span(v-else) Notificar
        strong Este proceso no se puede deshacer
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)

          .filtros(v-if="mostrarFiltros", key="filtros")
            .filtro(v-if="perfil === 'recursos humanos'")
              .codigo-empleado
                .control.title-singular
                  p Empleado
                  .input-container
                    input.input(
                      type="number",
                      v-model="filtros.codigoEmpleado"
                      @focus="mostrarBusquedaEmpleado = true"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                    .erase-data(@click="filtros.codigoEmpleado = ''")
                      .icon
                        .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaEmpleado"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarEmpleado"
                        @close="mostrarBusquedaEmpleado = false"
                        :codigo="filtros.codigoEmpleado"
                      )

            .filtro
              .control.title-singular
                p Fecha finalización desde
                .input-container.display-flex
                  input.input(
                    type="date",
                    v-model="filtros.desde"
                    @blur="changeFecha"
                  )
            .filtro
              .control.title-singular
                p Fecha finalización hasta
                .input-container.display-flex
                  input.input(
                    type="date",
                    v-model="filtros.hasta"
                    @blur="changeFecha"
                        )

            .filtro
              .title-singular
                p ¿Firmado?
              .select.display-flex
                select.flex-1(v-model='filtros.firmado' @change="changeFiltro")
                  option(value="all") Todos
                  option(:value="1") Si
                  option(:value="0") No
            .filtro
              .title-singular
                p ¿Indeterminado?
              .select.display-flex
                select.flex-1(v-model='filtros.indeterminado' @change="changeIndeterminado")
                  option(value="all") Todos
                  option(:value="1") Si
                  option(:value="0") No

          .boton-container(key="boton-container")
            button.button(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
            button.button.is-primary.margin-button-top(@click="openModalNotificacionMasiva")
              span.icon.is-small
                i.fa.fa-envelope.fa-fw.fa-lg
              span Notificar a todos los filtrados
      .body(key="body")
        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin
        .information(v-else)
          table.table.is-striped.is-bordered(
            v-if="lista.length !== 0"
          )
            thead
              th Empleado
              th.hide-break-1 Duracion
              th.hide-break-1 Firmado
              th(v-if="perfil==='recursos humanos'")
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="(o, index) in lista"
                :key="index"
              )
                td
                  .td-wrapper.hint--bottom(:aria-label="'Contrato: ' + o.id")
                    span.hint--top(:aria-label="'Empleado: ' + o.dniEmpleado") {{ o.nombreEmpleado }}
                    .show-break-1.dates-wrapper
                      span.has-text-bold Duracion:&nbsp;
                      span {{ o.indeterminado ? 'Indeterminado' : o.fechaInicio + ' - ' + o.fechaFin }}
                    template(v-if="o.pathFirmado")
                      .show-break-1.seen
                        span.has-text-bold Firmado
                        span.icon
                          i.fa.fa-check.fs-12
                      .show-break-1.dates-wrapper
                        span.has-text-bold Fecha de firma:&nbsp;
                        span {{ o.fechaFirma }}
                td.hide-break-1
                  span(v-if="o.indeterminado") Indeterminado
                  .wrapper(v-if="!o.indeterminado")
                    span {{ o.fechaInicio }} - {{ o.fechaFin }}
                  .dates-wrapper(v-if="o.fechaFirma")
                    span.has-text-bold Fecha de firma:&nbsp;
                    span {{ o.fechaFirma }}
                td.text-align-center.hide-break-1
                  template(v-if="o.pathFirmado")
                    span.icon
                      i.fa.fa-check
                  template(v-else)
                    span
                td.text-center.flex.fdc(v-if="perfil==='recursos humanos'")
                    a.button.is-small(:href="o.pathContrato", target="_blank")
                      span.icon.is-small
                        i.fa.fa-paperclip.is-small.fs-12
                      span Ver adjunto
                    //- .contenedor-acciones
                    button.button.is-small.is-danger.mt-5(@click="confirmacionEliminar(o)")
                      span.icon.is-small
                        i.fa.fa-trash.fs-12
                      span Eliminar
          div(v-else)
            .message.is-warning
              .message-body No hay contratos que cumplan con los siguientes filtros
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
import { scrollTo } from '../util/scroll'
export default {
  name: 'reporte_contratos_component',
  data () {
    return {
      lista                     : [],
      isLoading                 : false,
      mostrarBusquedaEmpleado   : false,
      mostrarFiltros            : true,
      perfil                    : localStorage.getItem('perfilVacaciones'),
      filtros                   :{
        codigoEmpleado          : '',
        desde                   : '',
        hasta                   : '',
        firmado                 : 'all',
        indeterminado           : 'all'
      },
      mostrarModalEliminar: false,
      mostrarModalNotificar: false,
      contrato: {},
      isProcessing: false
    }
  },
  components: {
    LookupSmallEmpleado,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  created () {
    this.filtros = {...this.filtros, ...this.$route.query}
    this.fetch()
  },
  methods: {
    changeFecha () {
      if (this.indeterminado === 1) {
        this.indeterminado = 0
      }
      this.fetch()
    },
    changeIndeterminado () {
      if (this.filtros.indeterminado === 1) {
        this.filtros.desde = ''
        this.filtros.hasta = ''
      }
      this.fetch()
    },
    changeFiltro () {
      this.fetch()
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = { ...vm.filtros }
      apiGet(vm, '/contratos/obtener/reporte', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtros.codigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtros = {
        codigoEmpleado          : '',
        mes                     : 'all',
        anio                    : 'all',
        firmado                 : 'all',
        indeterminado           : 'all'
      }
      this.fetch()
    },
    notificar () {
      var vm = this
      if (vm.isProcessing) return
      apiPost(vm, '/contratos/notificar/no-firmados', {}, function (data) {
        notify(vm, 'success', 'Éxito', 'Se le notifico masivamente a los empleados')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isProcessing = false
        vm.mostrarModalNotificar = false
      })
    },
    openModalNotificacionMasiva () {
      this.mostrarModalNotificar = true
    },
    confirmacionEliminar (o) {
      var vm = this
      vm.contrato = {
        id: o.id
      }
      vm.mostrarModalEliminar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarEliminar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    eliminar () {
      var vm = this
      if (vm.isProcessing) return
      vm.isProcessing = true
      var obj = {id: vm.contrato.id}
      apiDelete(vm, '/contratos/eliminar', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        vm.contrato = {}
        vm.fetch()
        vm.mostrarModalEliminar = false
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isProcessing = false
        apiGet(vm, '/contratos/obtener/mis-contratos', {}, function (data) {
          vm.$store.dispatch('setContratosPorFirmar', data.lista.filter(a => !a.firmado).length)
        })
      })
    },
    closeModalEliminar () {
      var vm = this
      vm.contrato        = {}
      vm.mostrarModalEliminar = false
    },
    closeModalNotificar () {
      var vm = this
      vm.mostrarModalNotificar = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .fs-12
    font-size 12px
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        // width 100%
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px

  .contenedor-acciones
    display flex
    flex-wrap: wrap;
    .button
      flex 1
      margin 3px 5px

  .is-loading
    margin-top 10px

  .button.is-loading
    margin-top 0px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;

  .text-align-center
    text-align center

  .contenedor-frame
    position fixed
    background-color #ccc
    left 1
    top: 0px;
    left: 0px;
    width: 100%;
    height 100vh;
    padding 20px
    transition all 0.5s ease
    z-index: 9999

    .titulo
      display flex
      align-items center
      .texto
        flex 1
        text-align left
        font-size 25px
      .button
        margin-bottom 10px

    iframe
      width 100%
      height calc(100% - 30px);

  .card-footer-item:not(:last-child)
    border-right: 1px solid #dbdbdb
  .info-box-button
    border-radius 0
    border        0px

  .show-break-1
    display none
  .wrapper
    display flex
    justify-content left
    align-items left
    flex-direction column
  @media (max-width: 1035px)
    .filtros
      flex-direction column
      .filtro
        width 100%

  @media (max-width: 650px)
    .show-break-1
      display initial
    .hide-break-1
      display none
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column
        .seen
          background-color: #94b3e9;
          color: #fff23;
          padding: 0px 4px;
          margin-top: 3px;
          border-radius: 4px;
  @media (max-width: 520px)
    .boton-container
      .margin-button-top
        margin-top 5px
</style>



// WEBPACK FOOTER //
// Component_Reporte_Contratos.vue?06363c59